import { render, staticRenderFns } from "./avo.vue?vue&type=template&id=00da4e90&"
import script from "./avo.vue?vue&type=script&lang=js&"
export * from "./avo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports